import Repository from './Repository'

const URL_GET_HOME_CARE_BOOK = '/home-care-book'

export default {
  getHomeCareBook (payload) {
    return Repository.get(`${URL_GET_HOME_CARE_BOOK}/${payload.params.childId}`, payload)
  }
}
